module.exports = __webpack_public_path__ + "img/Free Response 11.fd9cbb24.png";